import LearningTracksAction from '../actions/learningTracks/LearningTracksAction'
import { LearningTrack, LearningTrackStep } from '../../interfaces/LearningTrack'

type State = {
  learningTracks?: LearningTrack[],
  latestTrack?: {
    track: LearningTrack,
    step: LearningTrackStep
  },
  showIntroModal: boolean,
  introModalViewed: boolean
  checkTrackCompleteModal:boolean,
  trackCompleteModalSeen:boolean,
  isOrgAdmin: boolean
  latestTrackStep?: LearningTrackStep
}

class LearningTracksReducer {

  public static initialState: State = {
    learningTracks: null,
    latestTrack: null,
    showIntroModal:false,
    introModalViewed:false,
    checkTrackCompleteModal:false,
    trackCompleteModalSeen:false,
    isOrgAdmin:false,
    latestTrackStep:null
  }

  static reducer = (state = LearningTracksReducer.initialState, action) => {
    switch (action.type) {

      // Intro modal
      case LearningTracksAction.SET_INTRO_MODAL_STATUS:
        return {
          ...state,
          showIntroModal: action.payload.showIntroModal
      }

      case LearningTracksAction.SET_INTRO_MODAL_VIEWED:
        return {
          ...state,
          introModalViewed: true
      }

      // Org admin user
      case LearningTracksAction.SET_ORG_ADMIN_STATUS:
        return {
          ...state,
          isOrgAdmin: action.payload.status
      }

      // Track complete modal
      case LearningTracksAction.CHECK_TRACK_COMPLETE_MODAL_STATUS:
        return {
          ...state,
          checkTrackCompleteModal: action.payload.status
      }

      case LearningTracksAction.SET_TRACK_COMPLETE_MODAL_VIEWED:
        return {
          ...state,
          trackCompleteModalSeen : true
      }

      // Tracks
      case LearningTracksAction.REQUEST_LEARNING_TRACKS:
        return {
          ...state,
          isFetching: true
      }

      case LearningTracksAction.RECEIVE_LEARNING_TRACKS:
        if (state.learningTracks) {
          return state
        }
        return {
          ...state,
          learningTracks: action.payload.learningTracks,
          isFetching: false
      }

      case LearningTracksAction.RECEIVE_LEARNING_TRACK_STEPS:
        let index = state.learningTracks.findIndex(track => track.id === action.payload.trackId)
        let t = Object.create(state.learningTracks[index])
        t.steps = action.payload.steps
        t.id = action.payload.trackId
        let tracks = [
          ...state.learningTracks.slice(0, index),
          ...[t],
          ...state.learningTracks.slice(index + 1)
        ]

        return {
          ...state,
          learningTracks: tracks
        }

      case LearningTracksAction.RECEIVE_LEARNING_TRACK_STEP:
        let trackIndex = state.learningTracks.findIndex(t => t.id === action.payload.trackId)
        let track = state.learningTracks[trackIndex]
        let stepIndex = track.steps.findIndex(s => s.id === action.payload.step.id)
        track.steps[stepIndex] = action.payload.step
        let learningTracks = [
          ...state.learningTracks.slice(0, trackIndex),
          ...[track],
          ...state.learningTracks.slice(trackIndex + 1)
        ]
        return {
          ...state,
          learningTracks: learningTracks
        }
        
      case LearningTracksAction.RECEIVE_LATEST_TRACK_STEP:
        return {
          ...state,
          latestTrackStep: action.payload.latestTrackStep
        }

      case LearningTracksAction.MARK_LEARNING_TRACK_STEP_AS_COMPLETE:
        return LearningTracksReducer.updatedStateForTrackStepCompletion(state, action.payload.track, action.payload.step, true)

      case LearningTracksAction.UNDO_MARK_LEARNING_TRACK_STEP_AS_COMPLETE:
          return LearningTracksReducer.updatedStateForTrackStepCompletion(state, action.payload.track, action.payload.step, false)

      case LearningTracksAction.REJECT_LEARNING_TRACK_STEP_AS_COMPLETE:
        return LearningTracksReducer.updatedStateForTrackStepCompletion(state, action.payload.track, action.payload.step, false) 
    }
    return state
  }

  private static updatedStateForTrackStepCompletion(state: State, track: LearningTrack, step: LearningTrackStep, value: boolean) {
    let stepIndex = track.steps.indexOf(step)
    track.steps[stepIndex].complete = value
    let trackIndex = state.learningTracks.indexOf(track)
    let learningTracks = [
      ...state.learningTracks.slice(0, trackIndex),
      ...[track],
      ...state.learningTracks.slice(trackIndex + 1)
    ]
    return {
      ...state,
      learningTracks: learningTracks
    }
  }
} 

export default LearningTracksReducer